import { memo } from 'react'
import './Button.css'

function ButtonComponent(props) {
	return (
		<button
			type={props?.type}
			onClick={props?.onClick}
			className="button"
			style={{backgroundColor: props?.background}}
			disabled={props?.disabled}
		>
			{ props?.title }
		</button>
	)
}

export const Button = memo(ButtonComponent)